import httpClient from './httpClient';

const add_todo = (todo) => httpClient.post('/api/td_todo',todo);
const update_todo = (todo) => httpClient.put('/api/td_todo/'+todo.id, todo);
const delete_todo = (todo) => httpClient.delete('/api/td_todo/'+todo.id);

export {
    add_todo,
    delete_todo,
    update_todo
}